<script>
import conversation_svg from "@img/how-to-buy/conversation.svg"

import star_svg from "@img/guarantee/star.svg"
import shield_svg from "@img/guarantee/shield.svg"
import money_svg from "@img/guarantee/money.svg"
import handshake_svg from "@img/guarantee/handshake.svg"

import gost_img from "@img/how-to-buy/gost.webp";
import car_img from "@img/how-to-buy/betonameshalka.webp";
import prices_img from "@img/how-to-buy/prices.webp";
import individual_img from "@img/how-to-buy/individual.webp";

import {isMobile} from "@js/helpers.ts";

export default {
    name: "HowToBuy",
    data() {
        return {
            items: [
                {
                    title: 'Сертифицированные ЖБИ изделия',
                    icon: star_svg,
                    side_img: gost_img,
                },
                {
                    title: 'Гарантия сроков поставки',
                    icon: shield_svg,
                    side_img: car_img,
                },
                {
                    title: 'Конкурентные цены на ЖБИ конструкции',
                    icon: money_svg,
                    side_img: prices_img,
                },
                {
                    title: 'Индивидуальный подход к каждому проекту',
                    icon: handshake_svg,
                    side_img: individual_img,
                },
            ],
            active_key: 0,
        }
    },
    setup() {
        return {conversation_svg}
    },
    computed: {
        isMobile() {
            return isMobile()
        }
    }
}
</script>

<template>
    <div class="pt-20">
        <div class="bg-[#F1EDFF]">
            <div class="container pt-20 pb-10 lg:pb-20">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-20">
                    <div class="flex items-center justify-start hidden lg:block">
                        <img class="h-full object-cover max-w-full rounded-tr-[96px] rounded-[16px] max-h-[450px] border border-gray-300 shadow-sm"
                             :src="items[active_key].side_img"
                             alt="Заказать звонок" title="Заказать звонок">
                    </div>
                    <div>
                        <h2 class="text-xl md:text-3xl font-semibold mb-5">
                            Железобетонные изделия (ЖБИ) и конструкции от производителя
                        </h2>
                        <p class="text-sm mb-10 font-medium">
                            Наша компания занимается производством и продажей железобетонных изделий (ЖБИ) и конструкций
                            для строительства жилых, коммерческих и промышленных объектов. Мы предлагаем широкий
                            ассортимент ЖБИ продукции, соответствующей стандартам ГОСТ, что гарантирует её прочность,
                            долговечность и устойчивость к различным нагрузкам.
                        </p>
                        <ol class="relative border-s border-indigo-600 border-dashed ms-5">
                            <li v-for="(item, key) in items" class="h-[40px] mb-8 ms-12 cursor-pointer"
                                @click.prevent="active_key = key">
                                <div class="flex"
                                     :class="[key === items.length -1 && isMobile ? 'items-end' :'items-center']">
                                    <div :class="{'ring-1 md:ring-4': active_key === key, 'ring-1': active_key !== key}"
                                         class="absolute flex items-center justify-center w-12 h-12 rounded-full -start-6 bg-[#F1EDFF] ring-indigo-600">
                                        <img :src="item.icon" class="w-6 h-6 fill-indigo-600"
                                             alt="Иконка" title="Иконка"/>
                                    </div>
                                    <h3 class="flex items-center text-sm md:text-lg font-semibold text-gray-900">
                                        {{ item.title }}
                                    </h3>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
